import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { ClientData } from '../../../auth/client/client.data';
import { UserRoleFilters, UserRoleQueryParams } from '../user-role.data';

@Component({
    selector: 'ifb-user-role-list-filter-dialog',
    templateUrl: './user-role-list-filter-dialog.component.html',
    standalone: false
})
export class UserRoleListFilterDialogComponent {
  form: UntypedFormGroup;

  constructor(public dialogRef: MatDialogRef<UserRoleListFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder
  ) {
    this.form = this.formBuilder.group({
      clientId: this.data.query.clientId || '',
      name: this.data.query.name || '',
      externalId: this.data.query.externalId || '',
      active: this.data.query.active || undefined
    });
  }

  static show(dialog: MatDialog, query: UserRoleQueryParams, clients: ClientData[]): Observable<any> {
    return dialog
      .open(UserRoleListFilterDialogComponent, {
        data: { query, clients },
        closeOnNavigation: true,
      })
      .afterClosed();
  }

  onConfirmed(formValues: unknown): void {
    this.dialogRef.close(new UserRoleFilters(formValues));
  }
}
